const MuiBaseLine = {
  MuiCssBaseline: {
    styleOverrides: ({ theme }) => ({
      body: theme.palette.background.main,
    }),
  },
};

export default MuiBaseLine;
